<template>
  <div>
    <v-col>
      <template>
        <StockInvoiceStakeholderDocuments
          :stockDocData="pallet.stockDocData"
          :stakeHolderName="$t('PALLET')"
          :source="'pallet'"
          :invoiceId="invoiceId"
          :isPreviewMode="isPreviewMode"
          @reloadInvoiceData="reloadInvoiceData"
        ></StockInvoiceStakeholderDocuments>
      </template>
    </v-col>
  </div>
</template>
<style scoped>
tr.previewTr th {
  font-size: 18px !important;
}
</style>
<script>
//General

import { permissionMixin } from "@/core/mixins/permissionMixin.js";
import StockInvoiceStakeholderDocuments from "@/modules/stock/components/actions/stockList/invoice/StockInvoiceStakeholderDocuments.vue";
//Stock Module
import _ from "lodash";
export default {
  name: "StockInvoiceStakeholderPallet",
  mixins: [permissionMixin],
  props: {
    pallet: {
      type: Object,
      default: function() {
        return {};
      }
    },
    invoiceId: {
      type: Number,
      default: 0
    },
    isPreviewMode: {
      type: Boolean,
      default: function() {
        return false;
      }
    }
  },
  components: {
    StockInvoiceStakeholderDocuments
  },
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  methods: {
    reloadInvoiceData() {
      this.$emit("reloadInvoiceData");
    }
  }
};
</script>
